//
//
//
//
//
//

import {
  registerAffiliate,
} from '@motionelements/core/src/api/affiliate';
import * as accountApi from '@motionelements/core/src/api/account';
import featureFlagMixin from '@motionelements/core/src/components/mixins/feature-flag.mixin.js';

import { mapState } from 'vuex';

export default {
  name: 'ReferralStartEarningBtn',
  mixins: [featureFlagMixin],
  computed: {
    ...mapState({
      isLoggedIn: state => state.user.isLoggedIn,
    }),
  },
  methods: {
    onClick() {
      if (!this.isLoggedIn) {
        if (this.isFeatureEnabled('affiliate_agreement_flow')) {
          window.location.href = this.$link(`/login?intended_url=${this.$link('/affiliate/join').url()}`).url();
          return;
        }
        if (this.isFeatureEnabled('auth-modals')) {
          this.$bvModal.show('login-modal');
        } else {
          window.location.href = this.$link(`/login?intended_url=${this.$link('/referral').url()}`).url();
        }
      }
      if (this.isFeatureEnabled('affiliate_agreement_flow')) {
        window.location.href = this.$link('/affiliate/join').url();
      } else {
        return registerAffiliate().then(() => {
          accountApi.getAccount().then((response) => {
            this.$store.dispatch('user/setMember', response.data.data);
          });
        });
      }
    },
  },
};
